import { createContext } from "react";

export type VersionType = 'v1' | 'v2';

interface VersionContextType {
    version: VersionType;
    setVersion: (version: VersionType) => void;
}

export const ContextVersion = createContext<VersionContextType>({
    version: 'v2',
    setVersion: () => {}
});

